import { render, staticRenderFns } from "./CreateBlacklistModal.vue?vue&type=template&id=588d6dbd&scoped=true"
import script from "./CreateBlacklistModal.vue?vue&type=script&lang=js"
export * from "./CreateBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d6dbd",
  null
  
)

export default component.exports